import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import App from './App.vue';
import router from './router';
import store from './store';
import '../assets/css/main.css';
import globalVars from './globalVars';
import { PropertyException } from './util/exceptions';


Vue.config.productionTip = false;

globalVars().then((data) => {
    if (!data.googleApiKey || !data.fcoUrl || !data.baseApi) {
        let propertiesNotFound = '';
        if (!data.googleApiKey) {
            propertiesNotFound += 'googleApiKey ';
        }
        if (!data.fcoUrl) {
            propertiesNotFound += 'fcoUrl ';
        }
        if (!data.baseApi) {
            propertiesNotFound += 'baseApi ';
        }
        throw new PropertyException(propertiesNotFound);
    }
    Vue.prototype.$globalVars = data;
    const { googleApiKey } = Vue.prototype.$globalVars;
    // Load plugins
    Vue.use(VueGoogleMaps, {
        load: {
            key: googleApiKey,
            libraries: 'places'
        }
    });
    store().then((theStore) => {
        // Mount the app
        new Vue({
            router,
            store: theStore,
            render: h => h(App)
        }).$mount('#app');
    });
});
